import { render, staticRenderFns } from "./register-forms-container.vue?vue&type=template&id=c8cfb1c2"
import script from "./register-forms-container.vue?vue&type=script&lang=js"
export * from "./register-forms-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports